import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import { Link } from "@reach/router";
import SearchBar from "./SearchBar";
import Toolbar from "@material-ui/core/Toolbar";
import store from "../../../../reduxstore";
const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper
  }
}));

function CategoryTabs(props) {
  const classes = useStyles();
  const { currentCategory, handleChangeCategory } = props;
  const [value, setValue] = useState(currentCategory);
  const { categoryOptions } = store.getState();
  function handleChange(event, newValue) {
    setValue(newValue);
  }

  return (
    <Toolbar disableGutters>
      {categoryOptions.length > 0 ? (
        categoryOptions.indexOf(currentCategory) !== -1 ||
        currentCategory === "" ? (
          <Tabs
            className={classes.root}
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            textColor="primary"
          >
            <Tab
              label="所有"
              value=""
              component={Link}
              to="/info/search/category="
            />
            {categoryOptions.map(label => (
              <Tab
                label={label}
                key={label}
                value={label}
                component={Link}
                to={`/info/search/category=${label}`}
              />
            ))}
            <SearchBar />
          </Tabs>
        ) : (
          "此构件分类不存在"
        )
      ) : null}
    </Toolbar>
  );
}

export default CategoryTabs;
